import { Building2 } from 'lucide-react';

const Header = () => {
  return (
    <header className="bg-white border-b border-slate-200 px-6 py-4 shrink-0" data-testid="app-header">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <Building2 className="w-6 h-6 text-sky-700" />
          <h1 className="text-3xl font-semibold tracking-tight text-slate-900">Route Finder</h1>
        </div>
        <p className="text-sm text-slate-600 ml-9">
          Intelligent correspondent banking route optimization powered by xGBoost ML model. Upload your CB routes database as alternate options, then upload SWIFT MX messages (pacs.008/pacs.009) - the system queries alternates from your database and uses the xGBoost API to determine the optimal path.
        </p>
      </div>
    </header>
  );
};

export default Header;
